import { ref } from "vue"; 

const isDirectiveDisabled = ref(false);

export function disableClickawayDirective() {
  isDirectiveDisabled.value = true;
}

export function enableClickawayDirective() {
  isDirectiveDisabled.value = false;
}

export const clickaway = {
  mounted(el, { value: callback }) {
    document.addEventListener('mouseup', (event) => {
      if (el.contains(event.target) || isDirectiveDisabled.value) {
        return;
      }
      callback();
    })
  }
}